import styled from 'styled-components';

import { useProfile } from 'context/profile';
import useWebsocketExport from 'hooks/useWebsocketExport';
import { createAnalyticsExport } from 'services/api/insights/analytics';
import { getAnalyticsFilters, useInsightsStore } from 'stores/insightsStore';

import { AnalyticsQueryParams } from '../../query/useAnalyticsInfiniteQuery';

import Export from './Export';

type Props = {
  disabled?: boolean;
  filename?: string;
  show?: boolean;
  params: AnalyticsQueryParams;
};

function ApiExport({ disabled = false, filename, show = true, params }: Props) {
  const { profile } = useProfile();
  const { initiateExport, exporting } = useWebsocketExport(createAnalyticsExport);
  const filters = useInsightsStore((state) => getAnalyticsFilters(state, profile));

  const handleClick = () => {
    initiateExport({ params: { ...params, filename }, filters });
  };

  return <StyledExport disabled={disabled} show={show} loading={exporting} onClick={handleClick} />;
}

export default ApiExport;

const StyledExport = styled(Export)`
  margin-left: auto;
`;
